import messages from '../assets/i18n';

const textNatureOrder = (lang, status) => {
  return (
    status && status !== undefined ?
      messages[lang].natureOrder[status] : ''
  )
}

export default textNatureOrder;